import {Component} from '@angular/core'
import {Router} from '@angular/router'
import { NuclearObservable } from '../../nuclear-observable'
import { BaseComponent } from '../../components/base.component'
import { CustomerActions } from '../../actions/customer-actions'
import {customerGetters} from '../../stores/customer-store'
import { Title } from '@angular/platform-browser'
import {Customer} from '../../types'

@Component({
  selector: 'new-customer-page',
  template: `
    <div class="left-nav-layout customer-signup">
      <div class="content-wrapper">
        <div class="left-nav">
          <nc-nav [customer]="customer"></nc-nav>
        </div>
        <div id="detail-content" class="detail-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `
})
export class NewCustomerPage extends BaseComponent {
  customer: Customer; // For passing to nc-nav
  constructor(customerActions: CustomerActions, router: Router) {
    const toastEl = document.getElementById('toast-container')
    if (toastEl) toastEl.style['margin-top'] = '0px'
    super()
    const titleService = new Title({})
    titleService.setTitle('Sign Up')

    customerActions.loadCustomers().then(() => {
      const customers = NuclearObservable.currentValue<Customer[]>(customerGetters.customers, { toJS: true })
      if (customers && customers.length > 0) {
        this.customer = customers[0]
        this.observeCustomer(this.customer.id, c => this.customer = c)
      }
      else {
        router.navigate(['/registration'])
      }
    })
  }
}
